import PropTypes from 'prop-types';
import React from 'react';

import Dispatcher from './dispatcher.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Stream = ({
    bgColour  = null,
    classes   = null,
    modules   = null,
    namespace = null
}) => {
    // render
    return (
        <>
            {modules?.map((module, idx) => {
                // module spacing class rules
                const moduleType = module?.__typename;
                const moduleTypeNext = modules[idx + 1]?.__typename;
                const moduleTypePrevious = modules[idx - 1]?.__typename;

                const classesSpacing = ['module'];
                if (
                    moduleType === 'TextFullWidth' ||
                    moduleType === 'TextWidthHeading' ||
                    moduleType === 'Text'
                ) {
                    if (
                        moduleTypeNext === 'Text' ||
                        moduleTypeNext === 'TextFullWidth' ||
                        moduleTypeNext === 'TextWithHeading'
                    ) {
                        classesSpacing.push('module--lesser-bottom');
                    }

                    if (
                        moduleTypePrevious === 'Text' ||
                        moduleTypePrevious === 'TextFullWidth' ||
                        moduleTypePrevious === 'TextWithHeading'
                    ) {
                        classesSpacing.push('module--lesser-top');
                    }

                    if (moduleTypePrevious === 'TextLarge') {
                        classesSpacing.push('module--less-top');
                    }
                }

                if (moduleType === 'TextLarge') {
                    if (
                        moduleTypeNext === 'Text' ||
                        moduleTypeNext === 'TextFullWidth' ||
                        moduleTypeNext === 'TextWithHeading'
                    ) {
                        classesSpacing.push('module--less-bottom');
                    }
                }

                let classesAll = [];
                if (classes) {
                    classesAll.push(classes);
                }

                if (classesSpacing) {
                    classesAll.push(...classesSpacing);
                }

                // render
                return (
                    <Dispatcher
                        bgColour={bgColour}
                        classes={classesAll.join(' ')}
                        index={idx}
                        key={`${(namespace ?? '')}-module-${idx}`}
                        module={module}
                        moduleTypeNext={moduleTypeNext}
                        moduleTypePrevious={moduleTypePrevious}
                        namespace={`${(namespace ?? '')}-module-${idx}`} />
                );
            })}
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    bgColour : PropTypes.string,
    classes  : PropTypes.string,
    modules  : PropTypes.array.isRequired,
    namespace: PropTypes.string
};

Stream.propTypes = propTypes;

Stream.displayName = 'ModuleStream';

export { Stream };

export default Stream;
